import React, { useMemo } from 'react';
import { Switch } from "@mui/material";
import DataTable from '../_Components/DataTable';

const DataGrid = ({ data }) => {


  const columns = useMemo(
    () => [
      {
        accessor: "name",
        Header: "نوع",
        width: '70px',
      },
      {
        accessor: "dispalyName",
        Header: "عنوان",
        width: '100px',
      },

      {
        accessor: "value",
        Header: "مقدار",
        width: '100px',
      },
      {
        accessor: "status",
        Header: "فعال",
        width: '70px',
        cell: (index) => {
          return (
            <>

              <Switch
                checked={index.status ? true : false}
                value="checkedB"
                color="primary"
                inputProps={{ 'aria-label': 'primary checkbox' }}

              />
              {/* <i className='fas fa-check text-success '></i> */}
              {/* <i className='fas fa-times text-danger '></i> */}
            </>
          )
        }
      },

      {
        accessor: "createdPersianTime",
        Header: "زمان ایجاد",
        width: '100px',
        // Cell: ({ row }) => (
        //      moment(row.createdPersianTime).format("jYYYY/jM/jD HH:mm")
        //   ),
      },
      // {
      //   accessor: "action",
      //   Header: "ویرایش",
      //   width: '150px',
      //   className: "text-center action-style",
      //   cell: (index) => {
      //     return (
      //       <>
      //         {/* <button
      //                             className="btn btn-light-info btn-sm mr-2 btn-icon"
      //                             onClick={this.editRecord.bind(this, record, index)}>
      //                             <i className='far fa-eye text-small'></i>
      //                             {/* مشاهده */}
      //         {/* </button > */}
      //         <button
      //           className="btn btn-light-primary btn-sm mr-2 btn-icon"
      //           onClick={this.editRecord.bind(this, index)}>
      //           <i className='far fa-edit text-small'></i>
      //           {/* ویرایش */}
      //         </button>
      //         {/* <button
      //                             className="btn btn-light-danger btn-sm btn-icon"
      //                             onClick={this.deleteRecord.bind(this, record, index)}>
      //                             <i className='far fa-trash-alt text-small'></i>
      //                             {/* حذف */}
      //         {/* </button > */}
      //       </>
      //     );
      //   }
      // }
    ]);


  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: 'advance',
    button: {
      excel: false,
      print: false
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className='fa fa-chevron-right'></i>,
        next: <i className='fa fa-chevron-left'></i>,
        last: "Last"
      }
    }
  }






  // editRecord = (index) => {
  //   this.props.callBack(index)
  // }

  // deleteRecord = (record, index) => {
  //   console.log("Delete record", index, record);
  // }
  return (
    <>
      {/* <DataTable
        config={config}
        columns={columns}
        data={data}
      /> */}

    </>



  );
}

export default DataGrid;